export const getFillColor = (opts) => {
  try {
    return opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex]
      .fillColor;
  } catch {
    return undefined;
  }
};
